// Bootstrap 3 leaves aria-hidden="true" on an open modal (WCAG 4.1.2). Drop it while the dialog is
// up and restore it on close, as Bootstrap 4 does.
(function () {
  var $ = window.jQuery;
  if (!$) {
    return;
  }
  $(document)
    .on('show.bs.modal', '.modal', function () {
      this.removeAttribute('aria-hidden');
    })
    .on('hidden.bs.modal', '.modal', function () {
      this.setAttribute('aria-hidden', 'true');
    });

  // Bootstrap closes a modal on Escape without preventDefault, so the page-level Escape handlers
  // (search overlay, mobile menu) would close the layer underneath too. Capture, so it runs first.
  document.addEventListener('keydown', function (event) {
    if ((event.key === 'Escape' || event.key === 'Esc') && event.target.closest && event.target.closest('.modal.in')) {
      event.preventDefault();
    }
  }, true);
})();
